import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { setFunctionViewedAction, setViewingFunctionModeAction } from 'actions';
import { ViewedFunctionCodes } from 'const';
import { useAppSelector, useDataLoad, useUserFunctionality } from 'hooks';
import { configSelector } from 'selectors';
import { getDataLoadRequests, isDefined } from 'utils';

const useViewedFunctions = () => {
  const config = useAppSelector(configSelector);

  const dispatch = useDispatch();
  const { functions, isViewingMode } = useAppSelector((state) => state.viewedFunctions);
  const currentStudent = useAppSelector((state) => state.currentStudent);
  const currentStudentPersonId = currentStudent.meshId;

  const { isParent, isStudent } = useUserFunctionality();
  const shouldLoadFunctionList = isParent || isStudent;

  useDataLoad({
    requests: getDataLoadRequests().viewedFunctions,
    shouldLoad: shouldLoadFunctionList,
    visibilitySettingsCheck: false,
  });

  const availableFunctions = useMemo(() => {
    if (!functions) return [];

    return functions.filter((func) => {
      if (func.code === ViewedFunctionCodes.archiveSearch && !config?.SHOW_ARCHIVE_SEARCH_PREVIEW) {
        return false;
      }

      // пускаем если:
      // не пришел флаг архивности ИЛИ флаг архивности равен false
      return !isDefined(func.isArchive) || func.isArchive === false;
    });
  }, [config?.SHOW_ARCHIVE_SEARCH_PREVIEW, functions]);

  const availableUnviewedFunctions = useMemo(() => {
    return availableFunctions.filter((func) => {
      // пускаем если:
      // 1) пришел флаг просмотра
      // 2) флаг просмотра равен false
      return isDefined(func.isViewed) && func.isViewed === false;
    });
  }, [availableFunctions]);

  const setFunctionViewMode = useCallback(() => {
    dispatch(setViewingFunctionModeAction(true));
  }, [dispatch]);

  const setFunctionViewed = useCallback(
    (functionCode: number) => {
      if (currentStudentPersonId) {
        dispatch(setFunctionViewedAction(currentStudentPersonId, functionCode));
      }
    },
    [dispatch, currentStudentPersonId],
  );

  return {
    availableFunctions,
    availableUnviewedFunctions,
    isFunctionViewMode: isViewingMode,
    setFunctionViewed,
    setFunctionViewMode,
  };
};

export default useViewedFunctions;
